<div class="row m-0">
  <div class="col-12" [ngClass]="{ card: !bulkWorkspaceAndDpCreation && !modalMode }">
    @if (!modalMode) {
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            @if (!bulkWorkspaceAndDpCreation) {
              <h1 data-test-id="page-title">{{ 'add_workspace_and_website_app' | translate }}</h1>
            }
            <div class="mt-4">{{ 'required_fields_label' | translate }}</div>
          </div>
        </div>
      </div>
    }

    <div class="card-body" [ngClass]="{ 'p-0': modalMode }">
      <div class="row">
        <div class="col-12" [ngClass]="{ 'col-lg-8 col-xl-6': !modalMode }">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-12">
                @if (modalMode) {
                  <div class="mt-4">{{ 'required_fields_label' | translate }}</div>
                } @else {
                  <h2>{{ 'workspace' | translate }}</h2>
                }
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <app-common-input
                  [form]="form"
                  [formValidationRequest$]="formValidationRequest$"
                  [context]="{
                    label: 'label_workspace_name',
                    field: WorkspaceForm.workspaceName,
                    overrideErrors: {
                      unique: 'form_error_unique_name' | translate,
                      maxlength: 'upsert_workspace_name_max_length_error_label' | translate: CHAR_LIMITS[$workspace.name],
                    },
                  }"
                >
                </app-common-input>
                <app-form-field-char-count
                  [field]="form.get(WorkspaceForm.workspaceName)"
                  [charLimit]="CHAR_LIMITS[$workspace.name]"
                >
                </app-form-field-char-count>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <app-common-textarea
                  [form]="form"
                  [formValidationRequest$]="formValidationRequest$"
                  [context]="{
                    label: 'label_workspace_description',
                    field: WorkspaceForm.workspaceDescription,
                    placeholder: '',
                  }"
                >
                </app-common-textarea>
                <app-form-field-char-count
                  [field]="form.get(WorkspaceForm.workspaceDescription)"
                  [charLimit]="CHAR_LIMITS[$workspace.description]"
                ></app-form-field-char-count>
              </div>
            </div>

            <div class="margin-top-md margin-bottom-md">
              <app-digital-property-form-details
                #formDetailsComponent
                shortenHeadingLayout="true"
                disableWorkspaceValidation="true"
                enableDomainRestrictionSettings="true"
                [tenantId]="tenantId"
                [formValidationRequest$]="formValidationRequest$"
                (formChanged)="websiteDetailsChanged($event)"
              ></app-digital-property-form-details>
            </div>

            @if (formDetailsComponent.isWebsite) {
              <div>
                <hr class="mb-4" aria-hidden="true" />
                <h2 class="margin-bottom-md">{{ 'label_monitoring' | translate }}</h2>
                <div class="d-flex margin-bottom">
                  <app-common-switch [name]="'dp-monitoring-switch'" [id]="'dp-monitoring-switch'" [(value)]="monitoringEnabled">
                    <span class="switch-label visually-hidden">
                      {{ 'monitoring_switch_label' | translate }}
                    </span>
                  </app-common-switch>
                </div>
                @if (monitoringEnabled) {
                  <app-monitoring-quick-setup
                    #quickMonitoringSettings
                    [url]="url"
                    [formValidationRequest$]="formValidationRequest$"
                    [toolName]="toolName"
                    [monitoring]="null"
                  ></app-monitoring-quick-setup>
                }
              </div>
            }

            <div class="row mt-4">
              <div class="col-12 d-flex gap-3">
                <button ds-button type="submit">
                  {{ 'form_save' | translate }}
                </button>
                @if (modalMode) {
                  <button
                    ds-button
                    [variant]="DsButtonVariants.secondary"
                    type="button"
                    (click)="onCancel()"
                    data-test-id="cancel-button"
                  >
                    {{ 'label_cancel' | translate }}
                  </button>
                } @else {
                  <a ds-button [variant]="DsButtonVariants.secondary" [routerLink]="tenantDetailsUrl" id="cancelLink">
                    {{ 'label_close' | translate }}
                  </a>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
